function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_11431",
  "data-name": "Path 11431",
  d: "M5801.571,783.649l-2.359-1.845a8.632,8.632,0,0,0,0-1.938l2.361-1.846a1.156,1.156,0,0,0,.279-1.475L5799.4,772.3a1.159,1.159,0,0,0-1.418-.511l-2.782,1.119a9.475,9.475,0,0,0-1.67-.97l-.427-2.954a1.137,1.137,0,0,0-1.136-.984h-4.92a1.134,1.134,0,0,0-1.13.976l-.427,2.963a9.843,9.843,0,0,0-1.668.971l-2.789-1.121a1.138,1.138,0,0,0-1.41.5l-2.457,4.251a1.148,1.148,0,0,0,.279,1.481l2.36,1.845a8.521,8.521,0,0,0,0,1.938l-2.361,1.845a1.157,1.157,0,0,0-.281,1.475l2.454,4.244a1.159,1.159,0,0,0,1.419.511l2.781-1.119a9.532,9.532,0,0,0,1.672.971l.427,2.952a1.136,1.136,0,0,0,1.13.985h4.92a1.136,1.136,0,0,0,1.134-.975l.427-2.963a9.908,9.908,0,0,0,1.669-.971l2.792,1.122a1.138,1.138,0,0,0,1.409-.5l2.465-4.268A1.155,1.155,0,0,0,5801.571,783.649Zm-12.068,2.535a5.348,5.348,0,1,1,5.348-5.348A5.348,5.348,0,0,1,5789.5,786.184Z",
  transform: "translate(-5777.004 -768)"
});

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_17016",
    "data-name": "Group 17016",
    width: 25,
    height: 25.672,
    viewBox: "0 0 25 25.672",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Settings.1d5c5337.svg";
export { ForwardRef as ReactComponent };